import {
  Component,
  ElementRef,
  Inject,
  Renderer2
} from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfigProvider } from "../../../config-provider.service";
import { UtilsProvider } from "../../../common/providers/utils-provider.service";
import { CurrentUser } from "../../../common/providers/current-user";
import { Router } from '@angular/router';
import { BreadcrumbProvider } from '../../../breadcrumb/providers/breadcrumb-provider';
import { SessionRow, SessionsProvider } from '../../providers/sessions-provider';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  MAT_DIALOG_DATA, MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { Session } from "../../../common/models/session";
import { Timeslot } from "../../../common/models/timeslot";
import { Organization } from "../../../common/models/organization";
import { NgIf } from "@angular/common";
import { SessionsSessionViewComponent } from "../session-view/session-view";
import { MatButton, MatIconButton } from "@angular/material/button";
import { MatTooltip } from "@angular/material/tooltip";
import { MatIcon } from "@angular/material/icon";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";
import { User } from "../../../common/models/user";

@Component({
  selector: 'sessions-session-view-dialog',
  providers: [],
  standalone: true,
  styleUrls: ['./session-view-dialog.scss'],
  imports: [
    MatDialogClose,
    MatDialogTitle,
    NgIf,
    SessionsSessionViewComponent,
    MatButton,
    MatTooltip,
    MatIconButton,
    MatDialogContent,
    MatDialogActions,
    MatIcon,
    TranslateModule,
  ],
  templateUrl: './session-view-dialog.html',
})
export class SessionsSessionViewDialogComponent {
  public session: Session = {} as Session;
  public timeslot: Timeslot = {} as Timeslot;
  public organization: Organization = {} as Organization;
  public athleteUser: User = {} as User;
  public sessionRow: SessionRow = {} as SessionRow;
  public isEditable = false;
  public isLoading = true;
  private isExitSafe;

  constructor(
    public conf: ConfigProvider,
    public currentUser: CurrentUser,
    public utils: UtilsProvider,
    public breadcrumbProvider: BreadcrumbProvider,
    private _router: Router,
    private _toaster: MatSnackBar,
    private _sessionsProvider: SessionsProvider,
    public dialog: MatDialogRef<SessionsSessionViewDialogComponent>,
    private _translater: TranslateService,
    private elRef: ElementRef,
    private renderer: Renderer2,
    @Inject(MAT_DIALOG_DATA) private _data : any
  ) {
    this.isExitSafe = _data.isExitSafe;
    this.loadPopupData(_data).subscribe({
      error: (error: any) => this.onError(error)
    });
  }

  private loadPopupData(_data: any): Observable<any> {
    return this._sessionsProvider.getSession({id: _data.sessionId, filled: true})
      .pipe(
        map((session: Session) => {
          this.session = session;
          this.timeslot = _data.timeslot;
          this.organization = _data.organization;
          this.athleteUser = _data.athleteUser;
          this.isEditable = _data.isEditable;
          this.sessionRow = this._sessionsProvider.createSessionRow(this.organization!, this.session, this.session.libraryId);
          this.isLoading = false;
      })
    );
  }


  public onEditClicked(): void {
    // 1) Si la séance a encore un library id, c'est qu'elle a pas encore été sauvée dans l'agenda
    // dans ce cas, on ne laisse pas modifier la séance
    // car sinon on va modifier celle de library au lieu de celle de l'athlète
    // (on disable pas le bouton parce que sinon l'utilisateur
    // ne sait pas pourquoi il peut pas le faire ...)
    if (!this.isExitSafe) {
      const message = this._translater.instant('You_must_save_the_calendar_first');
      this._toaster.open(message, '', { duration: 5000 });
      return;
    }

    this.redirectToSessionEditor()
  }

  private redirectToSessionEditor(): void {
    this._router.navigate([this.organization!.code, 'sessions', this.session.id , 'editor'], {
      queryParams: {
        backto: this._router.url
      }
    });
  }

  public onFeedbackNewClicked(): void {
    this._router.navigateByUrl(`/${this.organization!.code}/athletes/${this.athleteUser?.id}/feedback/session/timeslot/${this.timeslot?.id}/new`);
  }

  /**
   * Check if the session date is bigger than the current date
   */
  public sessionDateNotOverdue(): boolean {
    if (!this.timeslot) {
      return false;
    }
    const now = new Date();
    // fromDate is a wall-clock time but the API tags it with a 'Z' (UTC) suffix;
    // strip the timezone so the comparison uses local wall-clock time.
    const sessionDate = new Date(this.utils.ISODateToYmdHis(this.timeslot.fromDate ?? ''));

    return sessionDate > now;
  }

  private onError(error: any): void {
    console.error("SessionViewDialog : ", error);
  }

}
